/*
 *
 * GiftCardsList constants
 *
 */

import endPoints from '../../config/endPoints';

const DEFAULT_ACTION = '/GiftCardsList/DEFAULT_ACTION';
const FETCH_FILTER_SUCCESS = '/GiftCardsList/FETCH_FILTER_SUCCESS';
const FETCH_RESTURANTLIST_ERROR = '/RestaurantsList/FETCH_RESTURANTLIST_ERROR';
const FETCH_GIFTCARDLIST_SUCCESS = '/GiftCardsList/FETCH_GIFTCARDLIST_SUCCESS';
const STORE_CLIENT_ID = '/GiftCardsList/STORE_CLIENT_ID';
// export const ADDTOCART_SUCCESS = '/GiftCardsList/ADDTOCART_SUCCESS';

/**
 * @static
 */
const DEFAULT_PRODUCT_TYPES = 'evoucher,physical_voucher';
const DEFAULT_MERCHANDISE_PRODUCT_TYPES = 'merchandise';
const DEFAULT_EVOUCHER_MERCHANDISE = 'evoucher,merchandise';

const DEFAULT_GIFTCARD_CLIENT = 'payment_gateway';
const DEFAULT_GIFTCARD_PAYLOAD_BY_NAME = {
  category_names: '',
  client_ids: '',
  include: 'variations,variation_types',
  page: 1,
  payment_method: 'payment_gateway',
  per_page: 12,
  product_types: DEFAULT_PRODUCT_TYPES,
  vendor_ids: '',
};
const DEFAULT_GIFTCARD_PAYLOAD = {
  category_ids: '',
  client_ids: '',
  include: 'variations,variation_types',
  page: 1,
  payment_method: 'payment_gateway',
  per_page: 12,
  product_types: DEFAULT_PRODUCT_TYPES,
  vendor_ids: '',
};
const DEFAULT_GIFTCARD_SPECIAL_DEALS_AND_OFFERS = {
  category_ids: '',
  client_ids: '',
  include: 'variations,variation_types',
  page: 1,
  payment_method: 'payment_gateway',
  per_page: 12,
  product_types: DEFAULT_PRODUCT_TYPES,
  vendor_ids: '',
  min_discount: 5,
  max_discount: 100,
};
const DEFAULT_GIFTCARD_PAYLOAD_MANIPAL = {
  category_ids: '',
  client_ids: '',
  include: 'variations,variation_types',
  page: 1,
  payment_method: 'payment_gateway',
  per_page: 12,
  product_types: DEFAULT_MERCHANDISE_PRODUCT_TYPES,
  vendor_ids: '',
  client_series: endPoints.MANIPAL_SERIES,
};

const DEFAULT_GIFTCARD_PAYLOAD_PROPEL_CORPORATE_GIFTING = {
  category_ids: '',
  client_ids: '',
  include: 'variations,variation_types',
  page: 1,
  payment_method: 'payment_gateway',
  per_page: 12,
  product_types: DEFAULT_EVOUCHER_MERCHANDISE,
  vendor_ids: '',
  client_series: endPoints.PROPEL_CORPORATE_GIFTING,
};

const ADDTOCART_PAYLOAD_STRUCTURE = {
  skip_payable_validation: true,
  item: {
    product_variation_id: '',
    quantity: '',
    shipping_address: {
      email: '',
      phone_numbers: '',
    },
    free_field_value: null,
  },
};
const ADDTOCART_PAYLOAD_STRUCTURE_PHYSICALCARD = {
  skip_payable_validation: true,
  item: {
    product_variation_id: '',
    quantity: '',
    free_field_value: null,
  },
};

const VALIDATE_MERCHANDISE = (payload = {}, { isOnlyMerchandise = false, client_id, client_series = '' } = {}) => {
  const _payload = { ...payload };
  if (isOnlyMerchandise) {
    _payload.client_ids = client_id;
    _payload.product_types = client_series === endPoints.PROPEL_CORPORATE_GIFTING ? DEFAULT_EVOUCHER_MERCHANDISE : DEFAULT_MERCHANDISE_PRODUCT_TYPES;
    _payload.payment_method = DEFAULT_GIFTCARD_CLIENT;
  }
  return _payload;
};
export {
  DEFAULT_ACTION,
  FETCH_FILTER_SUCCESS,
  FETCH_RESTURANTLIST_ERROR,
  FETCH_GIFTCARDLIST_SUCCESS,
  STORE_CLIENT_ID,
  DEFAULT_PRODUCT_TYPES,
  DEFAULT_MERCHANDISE_PRODUCT_TYPES,
  DEFAULT_GIFTCARD_CLIENT,
  DEFAULT_GIFTCARD_PAYLOAD_BY_NAME,
  DEFAULT_GIFTCARD_PAYLOAD,
  ADDTOCART_PAYLOAD_STRUCTURE,
  ADDTOCART_PAYLOAD_STRUCTURE_PHYSICALCARD,
  DEFAULT_GIFTCARD_PAYLOAD_MANIPAL,
  VALIDATE_MERCHANDISE,
  DEFAULT_GIFTCARD_SPECIAL_DEALS_AND_OFFERS,
  DEFAULT_EVOUCHER_MERCHANDISE,
  DEFAULT_GIFTCARD_PAYLOAD_PROPEL_CORPORATE_GIFTING,
};



// WEBPACK FOOTER //
// client/containers/GiftCardsList/constants.js